import { useEffect } from 'react'

export function useAppUi() {
  useEffect(() => {
    document.body.classList.add('app-ui')
    return () => document.body.classList.remove('app-ui')
  }, [])
}
